export default {
    items: [
        {value: 1, label: 'День'},
        {value: 2, label: 'Неделя'},
        {value: 3, label: 'Месяц'},
    ]
}